import { render, staticRenderFns } from "./v-checkbox.vue?vue&type=template&id=5c252fa8&scoped=true&"
import script from "./v-checkbox.vue?vue&type=script&lang=js&"
export * from "./v-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./v-checkbox.vue?vue&type=style&index=0&id=5c252fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c252fa8",
  null
  
)

export default component.exports